import axiosInstance from '../functions/axiosInstance';
import server_config from '../ServerConfiguration';
import ProfilesByResourceType from "../dictionaries/ProfilesByResourceType";

const fevir_node_server_address = server_config["fevir_node_server_address"];

const getSearchResultsWithIncludedResourceTypes = async (searchQueryString, selectedResourceType, allowedResourceTypes, 
    selectedProfile = null, allowedProfiles = [], apiToken = null, earliestDate = null, latestDate = null) => {
    console.log("CALLING SERVER with getsearchresults from getSearchResultsWithIncludedResourceTypes")
    return await axiosInstance({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            "functionid": "getsearchresults",
            "apiToken": apiToken,
            'contextInfo': { "referenceEntry": true },
            'selectedResourceType': selectedResourceType,
            'allowedResourceTypes': allowedResourceTypes,
            'selectedProfile': selectedProfile,
            'allowedProfiles': allowedProfiles,
            'searchQueryString': searchQueryString.trim(),
            'earliestDate': earliestDate,
            'latestDate': latestDate
        },
    }).then((resp) => {
        if (resp?.data) {
            //resp.data is searchResults
            //resp.data = { "success": true, "searchResults": searchResults as Array, "includedResourceTypeValues": includedResourceTypeValues as Array };
            if (resp.data.success) {
                return [resp.data.searchResults, resp.data.includedResourceTypeValues];
            }
            console.log(resp.data);
            return [null, null];
        }
        console.log(resp)
        console.log("NO RESPONSE from getsearchresults API call");
    }).catch((error) => { console.log(error); });
};


const getSearchResults = async (searchQueryString, searchType, selectedResourceTypes,
    allowedProfiles = [], population = null, intervention = null, comparator = null, outcome = null, 
    earliestDate = null, latestDate = null, limitToMyResources = false, apiToken = null) => {
    let profileUrls;
    if (allowedProfiles?.length > 0) {
        let profileLookup = Object.assign({}, ...Object.values(ProfilesByResourceType));
        profileUrls = allowedProfiles.map(profileName => profileLookup[profileName]?.url).filter(Boolean); //Removes profileNames it can't find
    }
    console.log("CALLING SERVER with getsearchresults from getSearchResults")
    return await axiosInstance({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            "functionid": "getsearchresults",
            "apiToken": apiToken,
            'contextInfo': { "referenceEntry": true },
            'searchQueryString': searchQueryString.trim(),
            'searchType': searchType,
            'resourceTypeLimiter': selectedResourceTypes,
            'profileLimiter': allowedProfiles,
            'profileUrls': profileUrls,
            'population': population,
            'intervention': intervention,
            'comparator': comparator,
            'outcome': outcome,
            'earliestDate': earliestDate,
            'latestDate': latestDate,
            'limitToMyResources': limitToMyResources
        },
    }).then((resp) => {
        if (resp?.data) {
            //resp.data is searchResults
            //resp.data = { "success": true, "searchResults": searchResults as Array };
            if (resp.data.success) {
                //const includedResourceTypeValues = [...new Set(results.map(row => row.fhirresourcetype))].filter(type => type);
                //return [matchedItems, includedResourceTypeValues];
                return resp.data.searchResults; //[resp.data.searchResults, includedResourceTypeValues]
            }
            console.log(resp.data);
            return [];
        }
        console.log(resp)
        console.log("NO RESPONSE from getsearchresults API call");
    }).catch((error) => { console.log(error); });
};

export default getSearchResults;
export { getSearchResultsWithIncludedResourceTypes };